import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { FinanceAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/finance/finance-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const FinanceAccessRulesConst: Record<FinanceAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль FINANCE (Финансы) ---

  // --- Раздел FINANCE.SECTIONS.PLAN_FACT (Бюджетирование) ---
  // Вкладки
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BALANCE_REPORT_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.BALANCE_REPORT.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BALANCE_REPORT_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.BALANCE_REPORT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_SETTINGS_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.SETTINGS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_SETTINGS_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.SETTINGS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_PAYMENT_OUTGOING_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.PAYMENT_OUTGOING.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.PAYMENT_OUTGOING.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BUDGET_REQUEST_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.BUDGET_REQUEST.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BUDGET_REQUEST_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.BUDGET_REQUEST.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_BALANCE_SHEET_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.BALANCE_SHEET.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.BALANCE_SHEET.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_PLANNING_SCENARIO_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.PLANNING_SCENARIO.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_PLANNING_SCENARIO_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.tabs.PLANNING_SCENARIO.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Разрешения Plan Fact
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_ACCESS_TO_ALL_BUDGET_REQUESTS]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.permissions.ACCESS_TO_ALL_BUDGET_REQUESTS.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_EDIT_ALL_BUDGET_REQUESTS]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.permissions.EDIT_ALL_BUDGET_REQUESTS.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_DELETE_ALL_BUDGET_REQUESTS_COMMENTS]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.permissions.DELETE_ALL_BUDGET_REQUESTS_COMMENTS.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_CAN_APPROVE_BUDGET_REQUEST_INSTEAD_OF_ANOTHER]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.permissions.CAN_APPROVE_BUDGET_REQUEST_INSTEAD_OF_ANOTHER.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_EDIT_PREVIOUS_PLAN]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.permissions.EDIT_PREVIOUS_PLAN.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_PLAN_FACT_EDIT_DOCUMENT_RESTRICT_DATE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.PLAN_FACT.permissions.EDIT_DOCUMENT_RESTRICT_DATE.isAllowed': true
  },

  // --- Раздел FINANCE.SECTIONS.DOCUMENT (Документы) ---
  // Вкладки
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_REGISTRY_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.DOCUMENT_REGISTRY.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_REGISTRY_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.DOCUMENT_REGISTRY.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_TEMPLATE_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_TEMPLATE_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_VERIFY_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.VERIFY.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_VERIFY_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.VERIFY.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_BANK_STATEMENT_RULE_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.BANK_STATEMENT_RULE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_BANK_STATEMENT_RULE_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.BANK_STATEMENT_RULE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_ABC_ANALYSIS_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.ABC_ANALYSIS.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.ABC_ANALYSIS.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_SALARY_ACCRUAL_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.SALARY_ACCRUAL.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.SALARY_ACCRUAL.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_SALARY_ACCRUAL_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.SALARY_ACCRUAL.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.SALARY_ACCRUAL.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_SALARY_DISTRIBUTION_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.SALARY_DISTRIBUTION.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.SALARY_DISTRIBUTION.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_SALARY_DISTRIBUTION_WRITE]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.SALARY_DISTRIBUTION.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.SALARY_DISTRIBUTION.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_ANALYTICS_RESET_READ]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.ANALYTICS_RESET.enabled': true,
    'FINANCE.sections.DOCUMENT.tabs.ANALYTICS_RESET.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  // Разрешения Document
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_EDIT_OTHER_USER_DOCUMENTS]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.permissions.EDIT_OTHER_USER_DOCUMENTS.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_CAN_LOCK_DOCUMENTS]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.permissions.CAN_LOCK_DOCUMENTS.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_READ_OTHER_USER_BILLS]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.permissions.READ_OTHER_USER_BILLS.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_DOCUMENT_EDIT_OTHER_USER_BILLS]: {
    'FINANCE.enabled': true,
    'FINANCE.sections.DOCUMENT.permissions.EDIT_OTHER_USER_BILLS.isAllowed': true
  },

  // --- Раздел FINANCE.SECTIONS.BUSINESS (Сделки) ---
  // Вкладки
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_READ]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.DEAL.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_WRITE]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.DEAL.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEALS_GROUP_READ]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.DEALS_GROUP.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEALS_GROUP_WRITE]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.DEALS_GROUP.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_INTEGRATION_MEGAPLAN_READ]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.INTEGRATION_MEGAPLAN.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_INTEGRATION_MEGAPLAN_WRITE]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.INTEGRATION_MEGAPLAN.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_INTEGRATION_AMO_READ]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.INTEGRATION_AMO.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_INTEGRATION_AMO_WRITE]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.INTEGRATION_AMO.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_TYPE_READ]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.DEAL_TYPE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_TYPE_WRITE]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.DEAL_TYPE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_STATUS_READ]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.STATUS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DEAL_STATUS_WRITE]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.STATUS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_RENTAL_RATES_READ]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.RENTAL_RATES.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.RENTAL_RATES.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_RENTAL_RATES_WRITE]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.tabs.RENTAL_RATES.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Разрешения Business
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_READ_ALL_DEALS]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.permissions.READ_ALL_DEALS.isAllowed': true
  },
  [FinanceAccessRulesKeyEnum.FINANCE_BUSINESS_DELETE_OTHER_USER_DEAL_COMMENTS]: {
    'FINANCE.enabled': true,
    'BUSINESS.sections.BUSINESS.permissions.DELETE_OTHER_USER_DEAL_COMMENTS.isAllowed': true
  }
};
